import {
  postResource,
  getResource,
  putResource
  //deleteResource,
} from './Services';

export const handleSignin = (data, onSuccess, onFail) => {
  const path = 'api/Admin/Login';
  postResource(path, data, onSuccess, onFail, false);
};

export const sendVerificationCode = (data, onSuccess, onFail) => {
  const { email } = data;
  const path = `api/Admin/SendMail?email=${email}`;
  postResource(path, {}, onSuccess, onFail, false);
};
export const ConfirmLoginVerificationCode = (data, onSuccess, onFail) => {
  const path = 'api/Admin/ConfirmCode';
  postResource(path, data, onSuccess, onFail, false);
};

export const resetPassword = (data, onSuccess, onFail) => {
  const path = 'api/Admin/AddNewPassword';
  postResource(path, data, onSuccess, onFail, false);
};
// export const getAllUsers = (onSuccess, onFail) => {
//   const path = "api/users/allUsers";
//   getResource(path, onSuccess, onFail);
// };
export const getAllUsers = (onSuccess, onFail, data) => {
  const path = 'api/users/allUsers';
  postResource(path, data, onSuccess, onFail);
};
export const getPresentStudents = ({ lectureId }, onSuccess, onFail) => {
  const path = `api/users/GetLectureStudents?lectureId=${lectureId}`;
  getResource(path, onSuccess, onFail);
};

export const getAllGroupUsers = (data, onSuccess, onFail) => {
  const { groupId } = data;
  const path = `api/users/allGroupUsers?groupId=${groupId}`;
  getResource(path, onSuccess, onFail);
};
export const ChangeUserStatus = (data, onSuccess, onFail) => {
  const path = 'api/User/ChangeUserStatus';
  putResource(path, data, onSuccess, onFail);
};
export const getAllAdmins = (onSuccess, onFail) => {
  const path = 'api/admin/allAdmins';
  getResource(path, onSuccess, onFail);
};

export const addAdmins = (data, onSuccess, onFail) => {
  const path = 'api/Admin/addAdmin';
  postResource(path, data, onSuccess, onFail);
};
export const ChangeAdminStatus = (data, onSuccess, onFail) => {
  const { adminId, isActive } = data;
  const path = `api/admin/changeAdminStatus?adminId=${adminId}&isActive=${isActive}`;
  putResource(path, data, onSuccess, onFail);
};
export const getAllSheikhs = (onSuccess, onFail, data) => {
  const path = 'api/sheikh/allSheikhsForAdmins';
  postResource(path, data, onSuccess, onFail);
};
export const getAllSheikhsforApprove = (onSuccess, onFail) => {
  const path = 'api/sheikh/allSheikhsForAdminsForApprove';
  getResource(path, onSuccess, onFail);
};
export const ChangeSheikhStatus = (data, onSuccess, onFail) => {
  const { sheikhId, isAproved } = data;
  const path = `api/sheikh/changeSheikhStatus?sheikhId=${sheikhId}&isApproved=${isAproved}`;
  putResource(path, data, onSuccess, onFail);
};
export const getSheikhlecturesForApproveAttending = (data, onSuccess, onFail) => {
  const path = `api/lecture/getSheikhlecturesForApproveAttending`;
  postResource(path, data, onSuccess, onFail);
};
export const approveAttending = (data, onSuccess, onFail) => {
  const { lectureId, isAttended } = data;
  const path = `api/lecture/approveSheikhAttending?lectureId=${lectureId}&isAttended=${isAttended}`;
  putResource(path, data, onSuccess, onFail);
};
export const getAllGroupsReport = (data, onSuccess, onFail) => {
  const path = `api/groups/allGroupsReport`;
  getResource(path, data, onSuccess, onFail);
};
export const getUserSurvey = (data, onSuccess, onFail) => {
  const { userId } = data;
  const path = `api/users/userSurvey?userId=${userId}`;
  getResource(path, onSuccess, onFail);
};
export const getAllGroups = (onSuccess, onFail) => {
  const path = `api/groups/allGroups`;
  getResource(path, onSuccess, onFail);
};
export const assignUserToGroup = (data, onSuccess, onFail) => {
  const path = 'api/users/assignUserToGroup';
  postResource(path, data, onSuccess, onFail);
};
export const allNotInGroupUsers = (onSuccess, onFail) => {
  const path = `api/users/allNotInGroupUsers`;
  getResource(path, onSuccess, onFail);
};
export const addGroup = (data, onSuccess, onFail) => {
  const path = 'api/groups/addGroup';
  postResource(path, data, onSuccess, onFail);
};
export const getAllActiveSheikhs = (onSuccess, onFail) => {
  const path = 'api/sheikh/allSheikhs';
  getResource(path, onSuccess, onFail);
};
export const AssigntListOFUsersToGroup = (data, onSuccess, onFail) => {
  const path = 'api/groups/AssigntListOFUsersToGroup';
  postResource(path, data, onSuccess, onFail);
};
export const ChangeGroupStatus = (data, onSuccess, onFail) => {
  const { groupId, isActive } = data;
  const path = `api/groups/changeGroupStatus?groupId=${groupId}&isActive=${isActive}`;
  putResource(path, data, onSuccess, onFail);
};
export const getActivelectures = (onSuccess, onFail, data) => {
  const path = 'api/lecture/allActivelectures';
  postResource(path, data, onSuccess, onFail);
};
export const getUsersWithTheirLectures = (onSuccess, onFail, data) => {
  const path = 'api/lecture/getUsersWithTheirLectures';
  postResource(path, data, onSuccess, onFail);
};
export const getAllCategories = (onSuccess, onFail) => {
  const path = 'api/azkar/allCategories';
  getResource(path, onSuccess, onFail);
};

export const addCategory = (data, onSuccess, onFail) => {
  // data should be FormData object containing "name" and "image" file
  const path = 'api/azkar/addCategory';
  postResource(path, data, onSuccess, onFail, true); // true to indicate multipart/form-data if your helper supports that
};
export const editAzkarCategory = (data, onSuccess, onFail) => {
  // data should be FormData object containing "name" and "image" file
  const path = 'api/azkar/editCategory';
  putResource(path, data, onSuccess, onFail, true); // true to indicate multipart/form-data if your helper supports that
};
// ✅ Activate Adhkar
export const activateAdhkarCategory = (data, onSuccess, onFail) => {
  const path = 'api/azkar/activateCategory';
  putResource(path, data, onSuccess, onFail);
};

// ✅ Deactivate Adhkar
export const deactivateAdhkarCategory = (data, onSuccess, onFail) => {
  const path = 'api/azkar/deactivateCategory';
  putResource(path, data, onSuccess, onFail);
};
// ✅ Get all Adhkar
export const getAllAdhkar = (onSuccess, onFail) => {
  const path = 'api/azkar/all';
  getResource(path, onSuccess, onFail);
};

// ✅ Add new Adhkar
export const addAdhkar = (data, onSuccess, onFail) => {
  const path = 'api/azkar';
  postResource(path, data, onSuccess, onFail, true);
};
// ✅ edit  Adhkar
export const editAdhkar = (data, onSuccess, onFail) => {
  const path = 'api/azkar';
  putResource(path, data, onSuccess, onFail, true);
};

// ✅ Activate Adhkar
export const activateAdhkar = (data, onSuccess, onFail) => {
  const path = 'api/azkar/activate';
  putResource(path, data, onSuccess, onFail);
};

// ✅ Deactivate Adhkar
export const deactivateAdhkar = (data, onSuccess, onFail) => {
  const path = 'api/azkar/deactivate';
  putResource(path, data, onSuccess, onFail);
};

// ✅ Get all categories for Adhkar (reuse for dropdown)
export const getAllCategoriesFOrAzkar = (onSuccess, onFail) => {
  const path = 'api/azkar/allCategories';
  getResource(path, onSuccess, onFail);
};

// Parts
export const getAllParts = (onSuccess, onFail) => {
  const path = 'api/reward/partPoint';
  getResource(path, onSuccess, onFail);
};

export const updatePartPoint = (data, onSuccess, onFail) => {
  const path = 'api/reward/partPoint';
  putResource(path, data, onSuccess, onFail);
};

export const getUserPartPoint = (data, onSuccess, onFail) => {
  const { userId } = data;
  const path = `api/reward/getUserPartPoint?userId=${userId}`;
  getResource(path, onSuccess, onFail);
};

export const getPartPointSelectList = (onSuccess, onFail) => {
  const path = 'api/reward/partPointSelectList';
  getResource(path, onSuccess, onFail);
};

export const addUserPartPoint = (data, onSuccess, onFail) => {
  const path = 'api/reward/addUserPartPoint';
  postResource(path, data, onSuccess, onFail);
};
